<div class="inspection-search-shell">
  <div class="inspection-header-search-shell" data-testid="inspection-search-shell">
      <div class="inspection-search-header">
        <button type="button"
                class="inspection-search-back-button"
                aria-label="Close search"
                (click)="close()"
                data-testid="inspection-search-btn-back">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
        </button>
        <h1>Search</h1>
      </div>

      <div class="inspection-search-input-container">
        <span class="p-input-icon-left inspection-search-input-wrapper">
          <i class="pi pi-search input-wrap-prefix" aria-hidden="true"></i>
          <input id="inspection-search-input"
                type="search"
                pInputText
                class="inspection-search-input"
                placeholder="Search by room, item, or category..."
                [ngModel]="searchTerm()"
                (ngModelChange)="onSearchTermChange($event)"
                (keydown.enter)="saveActiveSearch()"
                data-testid="inspection-search-input" />
        </span>

        @if (hasActiveSearch()) {
          <button type="button"
                  class="inspection-search-clear-button"
                  aria-label="Clear search"
                  (click)="clearSearch()"
                  data-testid="inspection-search-btn-clear">
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        }
      </div>
    
  </div>
  <div class="inspection-footer-search-shell">
      <div class="inspection-search-content">
        @if (hasRecentSearches() && !hasActiveSearch()) {
          <section class="inspection-search-recent" data-testid="inspection-search-recent">
            <h2 class="inspection-search-section-title">Recent</h2>
            <div class="inspection-search-recent-list">
              @for (recentSearch of recentSearches(); track recentSearch) {
                <div class="inspection-search-recent-pill"
                    data-testid="inspection-search-recent-search">
                  <button type="button"
                          class="inspection-search-remove-recent-button"
                          [attr.aria-label]="'Remove recent search ' + recentSearch"
                          (click)="removeRecentSearch(recentSearch)"
                          data-testid="inspection-search-btn-remove-recent">
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>

                  <button type="button"
                          class="inspection-search-recent-button"
                          (click)="selectRecentSearch(recentSearch)">
                    {{recentSearch}}
                  </button>
                </div>
              }
            </div>
                    <button type="button"
                    class="inspection-search-clear-recent-button"
                    (click)="clearRecentSearches()"
                    data-testid="inspection-search-btn-clear-recent">
              Clear All
            </button>
          </section>
        }

        @if (!hasActiveSearch()) {
          <section class="inspection-search-categories" data-testid="inspection-search-categories">
            <h2 class="inspection-search-section-title">Browse by Category</h2>
            <div class="inspection-search-category-grid">
              @for (category of visibleCategories(); track category) {
                <button type="button"
                        class="inspection-search-category-button"
                        (click)="browseCategory(category)"
                        data-testid="inspection-search-category">
                  {{category}}
                </button>
              }
            </div>
          </section>
        } @else {
          <div class="inspection-search-match-count" data-testid="inspection-search-match-count">
            {{matchCount()}} {{ matchCount() === 1 ? 'match' : 'matches' }}
          </div>

          @if (filteredResults().length > 0) {
            <div class="inspection-search-results" data-testid="inspection-search-results">
              @for (result of filteredResults(); track result.id) {
                <button type="button"
                        class="inspection-search-result-row"
                        (click)="selectResult(result)"
                        data-testid="inspection-search-result">
                  <div class="inspection-search-result-copy">
                    <div class="inspection-search-result-meta">
                      <span class="inspection-search-result-room">
                        @for (segment of getHighlightedSegments(result.areaName); track $index) {
                          <span>{{segment.text}}</span>
                        }
                      </span>
                      <span class="inspection-search-result-separator">›</span>
                      <span>
                        @for (segment of getHighlightedSegments(result.categoryName); track $index) {
                          <span>{{segment.text}}</span>
                        }
                      </span>
                    </div>
                    <div class="inspection-search-result-text">
                      @for (segment of getHighlightedSegments(result.assertionText); track $index) {
                        <span [class.inspection-search-highlight]="segment.isMatch">{{segment.text}}</span>
                      }
                    </div>
                  </div>
                  @if (result.isReviewed) {
                    <i class="pi pi-check-circle inspection-search-reviewed-icon" aria-label="Reviewed"></i>
                  }
                </button>
              }
            </div>
          } @else {
            <div class="inspection-search-no-results" data-testid="inspection-search-no-results">
              <i class="pi pi-search" aria-hidden="true"></i>
              <div class="inspection-search-no-results-title">No matching inspection items</div>
              <div class="inspection-search-no-results-text">Try a different keyword or category.</div>
            </div>
          }
        }
      </div>
  </div>
</div>